import Mutations from '../../odata/mutations';

export default { ...new Mutations('applicationSetting'), ...new Mutations('applicationSettings') };
